import { IEventSystem } from "@dhx/ts-common/events";
import { RichTextEvents } from "../types";

export function listenCompositionEvents(events: IEventSystem<any>, isActive: () => boolean): () => void {
	const compositionStart = (e: CompositionEvent) => {
		if (isActive()) {
			events.fire(RichTextEvents.compositionStart);
		}
	};
	const compositionEnd = (e: CompositionEvent) => {
		if (isActive()) {
			events.fire(RichTextEvents.compositionEnd, [e.data]);
		}
	};
	const compositionUpdate = (e: CompositionEvent) => {
		if (isActive()) {
			events.fire(RichTextEvents.compositionUpdate, [e.data]);
		}
	};

	document.addEventListener("compositionstart", compositionStart);
	document.addEventListener("compositionend", compositionEnd);
	document.addEventListener("compositionupdate", compositionUpdate);

	return () => {
		document.removeEventListener("compositionstart", compositionStart);
		document.removeEventListener("compositionend", compositionEnd);
		document.removeEventListener("compositionupdate", compositionUpdate);
	};
}
